import SettingDocController from './setting.doc.controller';

export default {
    controller: SettingDocController,
    template: require('./setting.doc.tpl.html')
};
